import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

export default class Price extends Component {

  /* Methods */

  format(value) {
    return value.toFixed(2);
  }

  /* Render */

  render() {
    const { className, minimal } = this.props;

    const priceClassNames = classNames('price', className, { 'price--minimal': minimal });

    return (
      <span className={priceClassNames}>
        {this.renderPrice()}
        {this.renderNote()}
      </span>
    );
  }

  renderPrice() {
    const { value } = this.props;
    return (
      <span className="price__price">
        {`€ ${this.format(value)}`}
      </span>
    );
  }

  renderNote() {
    const { vatExcluded, vatIncluded } = this.props;

    if (!vatExcluded && !vatIncluded) return null;

    const key = vatExcluded ? 'general.vat.excluded' : 'general.vat.included';

    return (
      <div className="price__note">
        <FormattedMessage id={key} />
      </div>
    );
  }
}

Price.defaultProps = {
  className: '',
  value: 0,
};

Price.propTypes = {
  className: PropTypes.string,
  minimal: PropTypes.bool,
  value: PropTypes.number,
  vatExcluded: PropTypes.bool,
  vatIncluded: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./js/components/price/index.jsx